// Politique de validité du (nouveau) mot de passe. Mirroir de la validation serveur
// (back/webhooks/passwordPolicy.js) — garder les deux en phase.
//
// Règles :
//  - 10 caractères minimum (pas de maximum)
//  - au moins 1 minuscule [a-z]
//  - au moins 1 MAJUSCULE [A-Z]
//  - au moins 1 chiffre [0-9]
//  - au moins 1 caractère qui n'est ni lettre [A-Za-z] ni chiffre (symbole, ponctuation, accent, etc.)

export const PASSWORD_MIN_LENGTH = 10

const RE_LOWER = /[a-z]/
const RE_UPPER = /[A-Z]/
const RE_DIGIT = /[0-9]/
// Au moins un caractère qui n'est ni lettre ASCII ni chiffre (couvre symboles, ponctuation, accents…).
const RE_SYMBOL = /[^A-Za-z0-9]/

export interface PasswordCheck {
   minLength: boolean
   lower: boolean
   upper: boolean
   digit: boolean
   symbol: boolean
}

export function checkPassword(pwd: string | null | undefined): PasswordCheck {
   const p = pwd ?? ''
   return {
      minLength: p.length >= PASSWORD_MIN_LENGTH,
      lower: RE_LOWER.test(p),
      upper: RE_UPPER.test(p),
      digit: RE_DIGIT.test(p),
      symbol: RE_SYMBOL.test(p),
   }
}

export function isPasswordValid(pwd: string | null | undefined): boolean {
   const c = checkPassword(pwd)
   return c.minLength && c.lower && c.upper && c.digit && c.symbol
}
